import React from 'react'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import Toggle from 'react-toggle'
import './styles.scss'

interface Props {
  sort: boolean
  setSort: React.SetStateAction<any>
  labels: string[]
}

export const SortToggle = ({ sort, setSort, labels }: Props) => {
  return (
    <div className='toggleWrapper'>
      {/* <div className='toggleTitle'>{labels[0]}</div> */}
      <div className='switchcontainer'>
        <div className={'label ' + (!sort ? '' : 'off')}>{labels[1]}</div>
        <div className='toggleContainer'>
          <Toggle
            defaultChecked={sort}
            icons={false}
            onChange={e => {
              setSort(e.target.checked)
            }}
          />
        </div>
        <div className={'label right ' + (sort ? '' : 'off')}>{labels[2]}</div>
      </div>
    </div>
  )
}
